import Fetcher from '../../../services/fetcher'
import settings from '../../../settings';

const listBestOf = (yearsSelected: any, typeBestOf: any) => {
  return Fetcher.get(settings.bestOfApi + `/list/${yearsSelected}/${typeBestOf}`);
};

export default listBestOf;